<template>
    <div>
        <div v-if="feedback">
            <div v-html="feedback" class="rich-text"></div>
        </div>

        <div v-else>
            <div v-if="workspaceId">
                <DepartmentPicker :workspace-id="workspaceId" @select="updateDepartment($event)" />
            </div>

            <div v-if="Array.isArray(fields) && fields.length > 0 && !feedback">
                <div v-if="!departmentCode && departments && departments.length > 1">
                    <div class="campo">
                        <label class="label">{{ __('Departamento') }}</label>
                        <div class="relative">
                            <select class="input" v-model="selectedDepartmentId">
                                <option value="null">{{ __('Selecione...') }}</option>
                                <option v-for="d in departments" :key="d.id" :value="d.id">
                                    {{ d.nome }}
                                </option>
                            </select>
                            <div class="absolute inset-y-0 right-0 flex items-center mr-2">
                                <alo-icon icon="outline-chevron-down" class="w-5 h-5 text-gray-400" />
                            </div>
                        </div>
                    </div>
                </div>

                <FormClient ref="formClient" :fields="fields" :value="initialValue" />

                <GoogleCaptcha ref="captcha" v-if="googleCaptchaEnabled"></GoogleCaptcha>

                <button
                    @click="submit()"
                    class="ml-2 my-half-unit text-white rounded py-2 px-4"
                    :style="'background:' + (primaryColor ? primaryColor : '#3B82F6')"
                >
                    {{ submiting ? __('Enviando...') : __('Enviar / Abrir chamado') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import FormClient from '@App/Vue/Remote/Crud/FormClient'
import DepartmentPicker from './DepartmentPicker.vue'
import GoogleCaptcha from './GoogleCaptcha.vue'
import { updateMeta } from '@App/Meta'

const DEFAULT_FIELDS = [
    {
        label: __('Nome'),
        name: 'name',
        placeholder: __('Nome'),
        required: true,
    },
    {
        label: __('E-mail'),
        name: 'email',
        placeholder: __('E-mail'),
        required: true,
    },
    {
        label: __('Mensagem'),
        name: 'message',
        placeholder: __('Descreva sua mensagem'),
        type: 'textarea',
        required: true,
    },
]

export default {
    props: ['workspaceId', 'formToken', 'departmentCode', 'primaryColor', 'channel'],
    components: { DepartmentPicker, FormClient, GoogleCaptcha },
    data() {
        return {
            fields: DEFAULT_FIELDS,
            initialValue: Object.fromEntries(new URLSearchParams(document.location.search)),
            loading: false,
            selectedDepartmentId: null,
            department: null,
            departments: [],
            submiting: false,
            feedback: null,
            googleCaptchaEnabled: false,
        }
    },
    mounted() {
        console.log({
            workspaceId: this.workspaceId,
        })

        console.log({
            channel: this.channel,
        })

        this.loadFields()
    },
    watch: {
        /**
         * Toda vez que houver alteração no select de departamento, nós devemos atualizar o formulário.
         */
        department() {
            this.loadFields()
        },
    },
    methods: {
        async loadFields() {
            if (!this.department) {
                if (!this.formToken) {
                    this.fields = DEFAULT_FIELDS
                    this.notifyHeightChange()
                    return
                }
            }

            this.updateUploadMetaTags()

            try {
                this.loading = true

                let formKey = this.department ? this.department.id : this.formToken

                let { data } = await axios.get('/api/integration/forms/' + formKey, {
                    params: {
                        department_code: this.departmentCode,
                    },
                })

                this.googleCaptchaEnabled = !!data.google_captcha_enabled

                this.fields = data.fields || DEFAULT_FIELDS
                if (this.formToken && !this.departmentCode) {
                    this.departments = data.departments
                    if (this.departments.length === 1) {
                        this.selectedDepartmentId = this.departments[0].id
                    }
                }
            } catch (err) {
                this.fields = DEFAULT_FIELDS
            } finally {
                this.loading = false
                this.notifyHeightChange()
            }
        },

        updateUploadMetaTags() {
            if (this.department && this.department.id) {
                updateMeta('arquivavel-type', 'core_departamentos')
                updateMeta('arquivavel-id', this.department.id)
            } else {
                updateMeta('arquivavel-type', 'integration_forms')
                updateMeta('arquivavel-id', this.formToken)
            }
        },

        updateDepartment(department) {
            this.department = department
            this.notifyHeightChange()
        },

        notifyHeightChange() {
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    let $form = document.querySelector('[data-teclia-form]')
                    if (!$form) return
                    let rect = $form.getBoundingClientRect()
                    parent.postMessage({ type: 'height-change', height: rect.height }, '*')
                })
            })
        },


        async submit() {
            if (!this.$refs.formClient.isValid()) {
                alert(__('Por favor, preencha todos os campos.'))
                return
            }

            if (!this.department && !this.formToken) {
                alert(__('Por favor, selecione o departamento.'))
                return
            }

            this.submiting = true

            try {
                let captcha = {}
                if (this.$refs.captcha) {
                    let token = this.$refs.captcha.getToken()
                    if (!token) {
                        returnalert(__('Por favor, marque a opção reCAPTCHA antes de enviar o formulário.'))
                    }
                    captcha.google_captcha_token = token
                }

                let urlParams = Object.fromEntries(new URLSearchParams(document.location.search).entries())

                let { data } = await axios.post('/api/integration/forms/submissions', {
                    department_id: (this.department && this.department.id) || this.selectedDepartmentId,
                    department_code: this.departmentCode,
                    channel: this.channel,
                    ...urlParams,
                    ...this.$refs.formClient.serialize(),
                    ...captcha,
                })

                this.submiting = false
                if (data.success_submit) {
                    this.feedback = data.success_submit
                } else {
                    this.feedback = `
                        <div class="p-10 text-gray-700">
                            ${__('Seu atendimento foi aberto com sucesso!')}
                        </div>
                    `
                }
            } catch (err) {
                alert(__('Não foi possível enviar o formulário. Por favor tente novamente mais tarde.'))
            }
        },
    },
}
</script>